import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "select2/dist/css/select2.min.css";
import "daterangepicker/daterangepicker.css";
import "./assets/fonts/font-awesome5.css";
import "./assets/css/custom.css";
import "./assets/css/widgetchat.css";
import "./assets/css/chat.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "jquery";
import "select2";
import "moment";
import "daterangepicker";
import "c3";
import "d3";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>
);

reportWebVitals();
